import { queryOptions } from '@tanstack/react-query';

import type { WatchlistPageData } from './get-watchlist-page-data.ts';
import { getWatchlistPageData } from './get-watchlist-page-data.ts';

interface GetWatchlistPageDataQueryOptionsInput {
	readonly watchlistIndex: number;
}

export const WATCHLIST_PAGE_QUERY_KEY = ['watchlist-page'] as const;

export function getWatchlistPageQueryKey({ watchlistIndex }: GetWatchlistPageDataQueryOptionsInput) {
	return [...WATCHLIST_PAGE_QUERY_KEY, watchlistIndex] as const;
}

export function getWatchlistPageDataQueryOptions({ watchlistIndex }: GetWatchlistPageDataQueryOptionsInput) {
	return queryOptions<WatchlistPageData>({
		queryFn: () => getWatchlistPageData({ data: { watchlistIndex } }),
		queryKey: getWatchlistPageQueryKey({ watchlistIndex }),
	});
}
